const SaleTag = () => {
  return (
    <svg
      width="80"
      height="52"
      viewBox="0 0 80 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_29096_3813)">
        <path
          d="M4.25145 17.8422C4.38745 15.8697 5.94427 14.2925 7.91488 14.1308L72.2692 8.85053C74.7094 8.65032 76.7552 10.6697 76.5868 13.1123L75.1476 33.9873C75.0116 35.9598 73.4547 37.5371 71.4841 37.6987L7.12978 42.979C4.68958 43.1792 2.64375 41.1598 2.81217 38.7172L4.25145 17.8422Z"
          fill="#CF3736"
        />
      </g>
      <text
        transform="translate(16.9639 16.7179) rotate(-3.41468)"
        fill="white"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" } as React.CSSProperties}
        fontFamily="RedHatDisplay"
        fontSize="16"
        fontWeight="bold"
        letterSpacing="0px"
      >
        <tspan x="0.492188" y="16.204">
          SALE
        </tspan>
      </text>
      <defs>
        <style>
          {`
            @font-face {
              font-family: "RedHatDisplay";
              src: url("../../public/fonts/RedHatDisplay-Regular.ttf") format("truetype");
              font-weight: 400;
              font-style: normal;
            }
            @font-face {
              font-family: "RedHatDisplay";
              src: url("../../public/fonts/RedHatDisplay-SemiBold.ttf") format("truetype");
              font-weight: 600;
              font-style: normal;
            }
            @font-face {
              font-family: "RedHatDisplay";
              src: url("../../public/fonts/RedHatDisplay-Bold.ttf") format("truetype");
              font-weight: bold;
              font-style: normal;
            }
            @font-face {
              font-family: "RedHatDisplay";
              src: url("../../public/fonts/RedHatDisplay-Black.ttf") format("truetype");
              font-weight: 900;
              font-style: normal;
            }
          `}
        </style>
        <filter
          id="filter0_d_29096_3813"
          x="2.80273"
          y="8.837"
          width="75.7939"
          height="36.1562"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2" dy="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.297345 0 0 0 0 0.0841041 0 0 0 0 0.0827012 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_29096_3813"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_29096_3813"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default SaleTag
